import React, {useState, useEffect} from 'react';

const FaqBlock = ({onChange, value}) => {
  const [faqBlocks, setFaqBlocks] = useState(value.data || [{
    // using ms as ID, to use for key in react render
    id: Date.now(),
    title: 'Spørsmål',
    value: 'Svar'
  }]);

  useEffect(() => {
    onChange({
      data: faqBlocks
    });
  }, [faqBlocks]);

  const addFaqBlock = (e) => {
    e.preventDefault();
    setFaqBlocks([...faqBlocks, {
      id: Date.now(),
      title: 'Spørsmål',
      value: 'Svar'
    }]);
  };

  const removeFaqBlock = (e, i) => {
    e.preventDefault();
    setFaqBlocks(faqBlocks.filter((_, bIndex) => i !== bIndex));
  };

  const setFaqBlockTitle = (i, title) => {
    console.log('title: ', title);
    setFaqBlocks(faqBlocks.map((bValue, bIndex) => {
      if (bIndex !== i) {
        return bValue;
      }

      return {
        id: bValue.id,
        title: title,
        value: bValue.value
      };
    }));
  };

  const setFaqBlockValue = (i, value) => {
    setFaqBlocks(faqBlocks.map((bValue, bIndex) => {
      if (bIndex !== i) {
        return bValue;
      }

      return {
        id: bValue.id,
        title: bValue.title,
        value: value
      };
    }));
  };

  return <div>
    <div className="mf-margin-bottom-20 mf-margin-top-10">
      {faqBlocks.map((block, i) => <div key={block.id} className="form-group">
        {i > 0 && <hr />}
        <input onChange={(e) => setFaqBlockTitle(i, e.target.value)} type="text" value={block.title} className="form-control mf-margin-bottom-10" />
        <textarea onChange={(e) => setFaqBlockValue(i, e.target.value)} className="form-control mf-margin-bottom-10" value={block.value}></textarea>
        <button className="btn btn-danger btn-small mf-margin-bottom-10" onClick={(e) => removeFaqBlock(e, i)}>Fjern</button>
      </div>)}
    </div>
    <button onClick={addFaqBlock} className="btn btn-primary">Legg til spørsmål</button>
  </div>;
};

export default FaqBlock;
